import { useEffect, useRef, useState } from "react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-enterprise/styles/ag-grid.css";
import "ag-grid-enterprise/styles/ag-theme-quartz.css";
import "./RenewFollowup.scss";
import axios from "axios";
import Handlebars from "handlebars";

import { Button, message, Modal, Tag } from "antd";
export default function RenewFollowup(props) {
  const gridRef = useRef();

  const [bookingList, setBookingList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalFor, setShowModalFor] = useState("");
  const [htmlContent, setHtmlContent] = useState("");
  const [updateRowItme, setUpdateRowItem] = useState([]);
  const [selectedData, setSelectedData] = useState("");
  const [templateHTML, setTemplateHTML] = useState("");

  const fetchTemplateHTML = async () => {
    const response = await axios.get(
      "https://stage-apiplatform.finkraftai.com/api/misc/sendgrid/template/d-453d8b87723f4421bcda2f9c847ff277"
    );

    if (response.status) {
      setTemplateHTML(response.data.html_content);
    }
  };

  const compileTemplate = (template, data) => {
    const compiled = Handlebars.compile(template);
    return compiled(data);
  };

  useEffect(() => {
    fetchTemplateHTML();
    fetchBookingDetails();
  }, []);
  const fetchBookingDetails = async () => {
    const response = await axios.post(
      "https://stage-apiplatform.finkraftai.com/api/hotelgst/renew/bookings"
      // "http://localhost:7001/api/hotelgst/renew/bookings"
    );
    console.log("response", response);
    if (response.data.status) {
      setBookingList(response.data.data);
    }
  };

  const handlePreviewMail = (data) => {
    setShowModalFor("ORIGINAL");
    setHtmlContent(data.content);
    setShowModal(true);
  };

  const handleShowTemplate = (data) => {
    setShowModalFor("TEMPLATE");
    setHtmlContent(data.content);
    console.log("data:", data);
    let dynamicData = {
      company: data.booking_company_name,
      hotel_name: data.hotel_name,
      hotel: data.hotel_name,

      gstin: data.gstin,
      guest_name: data.booking_guest_name,
      address: data.company_address,
      check_in_date: data.booking_check_in_date,
      check_out_date: data.booking_check_out_date,
      bookingId: data.booking_confirmation_number,
    };
    let preparedHTML = compileTemplate(templateHTML, dynamicData);
    setSelectedData(preparedHTML);
    setShowModal(true);
  };

  const handleSendMail = async (bookingData) => {
    const payload = {
      docIds: [bookingData._id],
    };
    const response = await axios.post(
      "https://stage-apiplatform.finkraftai.com/api/hotelgst/renew/bookings/mail",
      // "http://localhost:7001/api/hotelgst/renew/bookings/mail",

      payload
    );
    if (response.status) {
      message.success("Mail Sent");
    } else {
      message.error("Could not sent mail");
    }
  };

  const onSelectionChanged = (event) => {
    const selectedRows = event.api.getSelectedRows();
    console.log("Selected Rows:", selectedRows);
  };

  const columnDefs = [
    {
      headerName: "Mail Sent Status",
      field: "mail_sent",
      width: 200,
      enableRowGroup: true,
      checkboxSelection: (params) => params.node.group || params.node.leaf, // Checkbox for group and child rows
      valueGetter: (params) => (params.data?.mail_sent ? "YES" : "NO"),
      cellRenderer: (params) =>
        params.data?.mail_sent ? (
          <Tag color="green">Yes</Tag>
        ) : (
          <Tag color="red">No</Tag>
        ),
    },
    {
      headerName: "Checkin Date",
      field: "booking_check_in_date",
      enableRowGroup: true,
      width: 200,
    },
    {
      headerName: "Checkout Date",
      field: "booking_check_out_date",
      enableRowGroup: true,
    },
    {
      headerName: "Booking Id/TRF-ID",
      field: "booking_confirmation_number",
      enableRowGroup: true,
      width: 200,
    },
    {
      headerName: "Original Email",
      field: "content",
      enableRowGroup: true,
      minWidth: 250,
      cellRenderer: (params) => (
        <Button size="small" onClick={() => handlePreviewMail(params.data)}>
          {" "}
          See Original Email
        </Button>
      ),
    },
    {
      headerName: "Template",
      field: "content",
      enableRowGroup: true,
      minWidth: 250,
      cellRenderer: (params) => (
        <Button size="small" onClick={() => handleShowTemplate(params.data)}>
          {" "}
          See Original Email
        </Button>
      ),
    },
    {
      headerName: "Company Name",
      field: "booking_company_name",
      enableRowGroup: true,
      minWidth: 250,
    },
    {
      headerName: "Company Address",
      field: "company_address",
      enableRowGroup: true,
      minWidth: 250,
      editable: true,
    },
    {
      headerName: "Company GSTIN",
      field: "gstin",
      editable: true,
      enableRowGroup: true,
      minWidth: 250,
    },
    {
      headerName: "Guest Name",
      field: "booking_guest_name",
      editable: true,
    },
    {
      headerName: "Hotel Name",
      field: "hotel_name",
      enableRowGroup: true,
    },
    {
      headerName: "Hotel Email",
      field: "hotel_email",
      editable: true,
      enableRowGroup: true,
    },
    {
      headerName: "Hotel Address",
      field: "hotel_address",
    },
    {
      headerName: "Hotel State",
      field: "hotel_state",
      enableRowGroup: true,
    },
    {
      headerName: "Hotel State Code",
      field: "hotel_state_code",
      enableRowGroup: true,
    },
    {
      headerName: "Hotel Pincode",
      field: "hotel_pincode",
      enableRowGroup: true,
    },
    {
      headerName: "Action",
      field: "",
      cellRenderer: (params) => (
        <Button
          type="primary"
          size="small"
          onClick={() => handleSendMail(params.data)}
        >
          {params.data?.mail_sent ? "Send Again" : "Send Mail"}
        </Button>
      ),
    },
  ];

  const gridOptions = {
    columnDefs,
    rowSelection: "multiple", // Allow multiple row selection
    groupSelectsChildren: true, // Selecting a group selects all children
    animateRows: true,
    onSelectionChanged: (event) => {
      const selectedRows = event.api.getSelectedRows(); // Get all selected rows
      console.log("Selected Rows:", selectedRows);
      setSelected(selectedRows.map((item) => item._id));
    },
  };

  const handleSendBulkMail = async () => {
    const payload = {
      docIds: selected,
    };
    const response = await axios.post(
      "https://stage-apiplatform.finkraftai.com/api/hotelgst/renew/bookings/mail",
      payload
    );
    if (response.status) {
      message.success("Mail Sent");
    } else {
      message.error("Could not sent mail");
    }
  };

  const updateTableRowItem = async () => {
    const payload = {
      items: updateRowItme,
    };
    const response = await axios.post(
      "https://stage-apiplatform.finkraftai.com/api/hotelgst/renew/bookings/update",
      // "http://localhost:7001/api/hotelgst/renew/bookings/update",

      payload
    );
    if (response.status) {
      message.success("Updated");
      setUpdateRowItem([]);
    } else {
      message.error("Could not update");
    }
  };

  const onCellValueChanged = async (params) => {
    const updatedRowData = params.data; // Get the updated row data
    gridRef.current.api.applyTransaction({ update: [updatedRowData] });

    if (params.newValue !== params.oldValue) {
      setUpdateRowItem((prevData) => [...prevData, updatedRowData]);
    }
  };

  return (
    <div className="RenewFollowup">
      {selected.length > 0 ? (
        <Button type="primary" onClick={handleSendBulkMail}>
          Send Mail
        </Button>
      ) : null}

      {updateRowItme.length > 0 ? (
        <Button onClick={updateTableRowItem}>Update Table Data</Button>
      ) : null}
      <div style={{ height: "100%" }} className="ag-theme-alpine">
        <AgGridReact
          columnDefs={columnDefs}
          rowData={bookingList}
          cacheBlockSize={100}
          maxBlocksInCache={10}
          gridOptions={gridOptions}
          rowSelection="multiple"
          groupDefaultExpanded={-1}
          //   sideBar={true}
          onRowValueChanged={(event) => console.log("Row changed:", event.data)}
          rowGroupPanelShow={"always"}
          ref={gridRef}
          groupSelectsChildren={true} // Enable select all for groups
          animateRows={true}
          defaultColDef={{
            flex: 1,
            editable: false,
            resizable: true,
            minWidth: 250,
          }}
          onCellValueChanged={onCellValueChanged} // Register the event handler for cell value changes
        />
      </div>
      <Modal
        width={800}
        open={showModal}
        onCancel={() => setShowModal(false)}
        footer={false}
      >
        <div
          style={{ height: 600, overflowY: "auto" }}
          dangerouslySetInnerHTML={{
            __html: showModalFor === "ORIGINAL" ? htmlContent : selectedData,
          }}
        ></div>
      </Modal>
    </div>
  );
}
